import { schemeColor } from 'shared/assets/styles/scheme-color.style';
import styled from 'styled-components';

export const IconContainer = styled.span<{ $color: string }>`
  color: ${({ $color, theme }) => schemeColor($color, theme) ?? 'inherit'};
  line-height: 62.5%;
`;

export const CheckIconContainer = styled.span`
  color: ${({ theme }) => theme.palette.primaryExtended.opacityBackgroundText};
  line-height: 62.5%;
`;
